import { useEffect, useState } from "react";
import { PixPayload } from "../models/IPixPayment";

import { Types } from "@ioc/types";
import { IGetPixByOrderService } from "@modules/orders/models/IGetPixByOrderService";
import { useIoCContext } from "@context/IoCContext/IoCContext";

export function usePixByOrder(salesOrderNumber: string | null) {
  const iocContext = useIoCContext();
  const getPixByOrderService = iocContext.serviceContainer.get<
    IGetPixByOrderService
  >(Types.Orders.IGetPixByOrderService);

  const [loading, setLoading] = useState(true);
  const [payloads, setPayloads] = useState<PixPayload[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!salesOrderNumber) {
      setLoading(false);
      return;
    }
    async function run() {
      try {
        setLoading(true);
        const result = await getPixByOrderService.execute(salesOrderNumber);
        setPayloads(result);
      } catch (err: any) {
        setError(err.message ?? "Erro inesperado");
      } finally {
        setLoading(false);
      }
    }

    if (salesOrderNumber) run();
  }, [getPixByOrderService, salesOrderNumber]);

  return { loading, payloads, error };
}
